import { createContext } from 'react';

/**
 * App-specific dependencies the messaging lib needs but does not own.
 * Each consuming app supplies these by mounting <MessagingProvider>.
 *
 * - transport: the app's HTTP POST (register: api/HttpHelpers `post`;
 *   mobile-checkout: utils/helpers/http). Used by the auth/config queries.
 * - logger / metrics: the app's logging + metrics, used by the Ably/Pusher hooks.
 */
export type MessagingTransport = <T>(path: string, body: unknown) => Promise<T>;

export type MessagingLogger = {
  error: (message: string, context?: object) => void;
  warn: (message: string, context?: object) => void;
  info: (message: string, context?: object) => void;
  debug: <T = unknown>(message: string, context?: object) => void;
};

export type MessagingMetrics = {
  addCount: (name: string, options?: object) => void;
};

export type MessagingDeps = {
  transport: MessagingTransport;
  logger: MessagingLogger;
  metrics: MessagingMetrics;
};

export const MessagingContext = createContext<MessagingDeps | null>(null);
